import * as React from 'react';
import { toast } from 'react-toastify';
import * as DateHelpers from './DateHelpers';
import { Link } from 'react-router-dom';
import AddNewScheduleData from './ScheduleNewAddModal';
import EditNoteModal from './EditNotes';
import RescheduleJobData from './ScheduleNewRescheduleModal';
import JobScheduleVoidModalData from './JobScheduleVoidModal';
import ConfirmPopups from './ConfirmPopup';
import NotesPopup from './NotesPopup';
import JobInfoData from './ScheduleNewJobInfoModal';
import CopyJobData from './ScheduleNewCopyJobModal';
import FlaggedJobsData from './ScheduleNewFlaggedJobsModal';
import type { AddNewResults, CopyScheduleItem, ItemOrder, JobItem, KwikstageJobItem, NewManualItem, SaveItem, ScheduleDay, ScheduleItems } from './models/JobScheduleInterfaces';
import type { EditNoteItem, GenericList, PublicHoliday, ShutdownPeriod } from './models/JobSharedInterfaces';
import { GetQuery, PostQuery } from './Shared';

interface ScheduleDayProps {
    allowEdit: boolean;
    allowAllocateToPastDate: boolean;
    allowUpdateDayLimits: boolean;
    allowLock: boolean;
    allowGetAccountBalance: boolean;
    scheduleDay: ScheduleDay;
    scheduleBranchId: number;
    noteTypes: GenericList[];
    publicHolidays: PublicHoliday[];
    shutdownPeriods: ShutdownPeriod[];
    reasonOptions: GenericList[];
    scheduleTypes: GenericList[];
    scheduleWarningNo: number;
    scheduleBookedNo: number;
    loadingDay: boolean;    //used when refreshing the day
    updateScheduleDay(scheduleDate: string, scheduleDay: ScheduleDay): void;
    updateDay(scheduleDate: string, refreshDayOnly: boolean): void;
    saveDay(scheduleDate: string): void;
    saveDayOrder(scheduleDate: string, items: ItemOrder[]): void;
    goAllocate(scheduleDate: string): void;
    view(dateSelected: string, searchScheduleId: number): void;
}

const WalkWayGuardRailPitchWarningNo: number = 4;
const VoidWarningNo: number = 3;
const KwikstageWarningNo: number = 250;

interface RowProps {
    index: number;
    indexJob: number;
    scheduleDayStatusId: number;
    item: ScheduleItems;
    allowEdit: boolean;
    allowAllocateToPastDate: boolean;
    minDate: string;
    onCellChange: (e: any, jobOnly: boolean, indexJob: number, itemIndex: number) => void;
    onCellCheckboxChange: (e: any, jobOnly: boolean, indexJob: number, itemIndex: number) => void;
    editNotes: (e: any, jobOnly: boolean, indexJob: number, itemIndex: number) => void
    showInfo: (e: any, jobOnly: boolean, indexJob: number, indexItem: number) => void;
    copyItem: (e: any, jobOnly: boolean, indexJob: number, itemIndex: number) => void;
    rescheduleItem: (e: any, jobOnly: boolean, indexJob: number, itemIndex: number) => void;
    cancelItem: (e: any, jobOnly: boolean, indexJob: number, itemIndex: number) => void;
    invoiceItem: (e: any, jobOnly: boolean, indexJob: number, itemIndex: number) => void;
}

//ITEMS
const ItemRow: React.FC<RowProps> = ({ index, indexJob, scheduleDayStatusId, item, allowEdit, allowAllocateToPastDate, minDate, onCellChange, onCellCheckboxChange, editNotes, showInfo, copyItem, rescheduleItem, cancelItem, invoiceItem }) => {
    return (
        <tr key={index} className={item.typeId === 1 ? "tableColours--install" : item.typeId === 2 ? "tableColours--pickup" : item.typeId === 3 ? "tableColours--assist" : item.typeId === 4 ? "tableColours--cleaning" : "tableColours--manual"}>
            <td className="hidden">{item.id}</td>
            <td className={"table__text--align table--col-xs " + (item.reckonUpdatesRequired ? "allocate__customerReckonText" : item.customerUpdatesRequired ? "allocate__customerText" : "")}>{item.jobIndex}</td>
            <td className="table__text--align table--col-xs">
                <div>
                    <a href="#" onClick={(e) => showInfo(e, false, indexJob, item.itemIndex)}>
                        <span className="fas fa-info-circle copy--icon alignIconCenter tooltipitem tooltipitem__right"><span className="tooltipitemtext tooltipitemtext__right">Booking Information</span></span>
                    </a>
                </div>
            </td>
            <td className={"table__text--align table--col-s " + (item.reckonUpdatesRequired ? "allocate__customerReckonText" : item.customerUpdatesRequired ? "allocate__customerText" : "")}>
                {item.orderManual}
            </td>
            <td className={"table__text--align"}>
                <Link className={item.jobId == 0 ? "hidden" : (item.reckonUpdatesRequired ? "allocate__customerReckonText" : item.customerUpdatesRequired ? "allocate__customerText" : "")} to={'/job/' + item.jobId + '/details'} target="_blank">
                    <div className="tooltipitem tooltipitem__right">{item.siteAddress.length > 30 ? item.siteAddress.substring(0, 30) + "... " : item.siteAddress}
                        <span className="tooltipitemtext tooltipitemtext__right">{item.siteAddress}</span>
                    </div>
                </Link>
                <div className={item.jobId != 0 ? "hidden" : "tooltipitem tooltipitem__right"}>{item.siteAddress ? item.siteAddress.substring(0, 20) + "... " : ""}
                    <span className="tooltipitemtext tooltipitemtext__right">{item.siteAddress}</span>
                </div>
            </td>
            <td className={"table__text--align"}>
                <Link className={item.customerId == 0 ? "hidden" : (item.reckonUpdatesRequired ? "allocate__customerReckonText" : item.customerUpdatesRequired ? "allocate__customerText" : "")} to={'/customer/' + item.customerId} target="_blank">
                    <div className="tooltipitem tooltipitem__right">{item.customer.length > 15 ? item.customer.substring(0, 15) + "... " : item.customer}
                        <span className="tooltipitemtext tooltipitemtext__right">{item.customer}</span>
                    </div>
                </Link>
            </td>
            <td className={"table__text--align table--col-s " + (item.reckonUpdatesRequired ? "allocate__customerReckonText" : item.customerUpdatesRequired ? "allocate__customerText" : "")}>
                <div className="tooltipitem tooltipitem__right">{item.manualItem ? item.description.substring(0, 5) + "... " : item.itemShortcut}
                    <span className="tooltipitemtext tooltipitemtext__right">{item.manualItem ? item.description : item.item}</span>
                </div>
            </td>
                <td className={"table__text--align table--cell--nowrap table--col-s "  + (item.reckonUpdatesRequired ? "allocate__customerReckonText" : item.customerUpdatesRequired ? "allocate__customerText" : "")}>
                <span className="tooltipitemtext tooltipitemtext__right">{item.quantityType}</span>
            </td>
                <td className={"table__text--align table--col-m "  + (item.reckonUpdatesRequired ? "allocate__customerReckonText" : item.customerUpdatesRequired ? "allocate__customerText" : "")}>
                <input name="onOffhireDate" type={!item.reckonUpdatesRequired && !item.customerUpdatesRequired && item.allowEdit && !item.manualItem && scheduleDayStatusId === 1 ? 'date' : "hidden"} min={minDate} className="form-control schedulenew__date-size" value={item.onOffhireDate} onChange={(e) => onCellChange(e, false, indexJob, item.itemIndex)} />
                {!item.reckonUpdatesRequired && !item.customerUpdatesRequired && item.allowEdit && scheduleDayStatusId === 1 ? "" : item.onOffhireDateFormatted}
            </td>
            <td className={"table__text--align table--col-s "  + (item.reckonUpdatesRequired ? "allocate__customerReckonText" : item.customerUpdatesRequired ? "allocate__customerText" : "")}>
                <div className="tooltipitem tooltipitem__right">{item.accountTypeId === 1 ? "COD" : item.accountTypeId === 2 ? "Acc" : item.accountTypeId === 3 ? "Acc PO" : ""}
                    <span className="tooltipitemtext tooltipitemtext__right">{item.accountType}</span>
                </div>
            </td>
            <td className="table__text--align table--col-s">
                
            </td>
            <td className="table__text--align table--col-s">
                { item.typeId === 1 ? item.jobAmountFormatted : "" }
            </td>
            <td className={"table__text--align table--col-s "  + (item.reckonUpdatesRequired ? "allocate__customerReckonText" : item.customerUpdatesRequired ? "allocate__customerText" : "")}>
                <input name="accountChecked" type='checkbox' className={(item.allowEdit && item.typeId === 1) ? "input" : "hidden"} checked={item.accountChecked} onChange={(e) => onCellCheckboxChange(e, false, indexJob, item.itemIndex)} disabled={scheduleDayStatusId === 2 || !item.allowEdit} />
            </td>
            <td className={"table__text--align table--col-s " + (item.reckonUpdatesRequired ? "allocate__customerReckonText" : item.customerUpdatesRequired ? "allocate__customerText" : "")}>
                <input name="goAhead" type='checkbox' className={item.allowEdit ? "input" : "hidden"} checked={item.goAhead} onChange={(e) => onCellCheckboxChange(e, false, indexJob, item.itemIndex)} disabled={scheduleDayStatusId === 2 || !item.allowEdit} />
            </td>
            <td className="table__text--align table--col-s allocate-notes--width">
                <a className={item.scheduleNotes == "" ? "hidden" : item.showRedNotes ? " makeitred" : ""} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => editNotes(e, false, indexJob, item.itemIndex)}>
                    <div className="tooltipitem tooltipitem__left">{item.scheduleNotes ? item.scheduleNotes.length < 60 ? item.scheduleNotes : item.scheduleNotes.substring(0, 60) + "... " : ""}
                        <span className="tooltipitemtext tooltipitemtext__large tooltipitemtext__left">{item.scheduleNotes}</span>
                    </div>
                </a>
                <a className={item.scheduleNotes != "" ? "hidden" : item.showRedNotes ? " makeitred" : item.showGreenNotes ? " makeitgreen" : ""} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => editNotes(e, false, indexJob, item.itemIndex)}>
                    <span className="fas fa-pencil-alt edit--icon"></span>
                </a>
            </td>
            <td className="table__text--align table--col-xs">
                <div className={(allowEdit || allowAllocateToPastDate) && item.allowEdit && scheduleDayStatusId === 1 ? "copy--tablecell" : "hidden"}>
                    <a href="#" onClick={(e) => copyItem(e, false, indexJob, item.itemIndex)}>
                        <span className="fas fa-copy copy--icon alignIconCenter tooltipitem tooltipitem__left"><span className="tooltipitemtext tooltipitemtext__left">Roll over job to another day</span></span>
                    </a>
                </div>
            </td>
            <td className="table__text--align table--col-xs">
                <div className={(allowEdit || allowAllocateToPastDate) && item.allowDelete && scheduleDayStatusId === 1 ? "" : "hidden"}>
                    <a href="#" onClick={(e) => rescheduleItem(e, false, indexJob, item.itemIndex)}>
                        <span className="fas fa-calendar-alt copy--icon alignIconCenter tooltipitem tooltipitem__left"><span className="tooltipitemtext tooltipitemtext__left">Reschedule job to another day</span></span>
                    </a>
                </div>
            </td>
            <td className="table__text--align table--col-xs">
                <div className={item.typeId === 1 && allowEdit && !item.reckonUpdatesRequired && !item.customerUpdatesRequired && item.allowEdit && item.allowInvoice && scheduleDayStatusId === 1 ? "" : "hidden"}>
                    <a href="#" onClick={(e) => invoiceItem(e, false, indexJob, item.itemIndex)}>
                        <span className="fa-solid fa-file-invoice-dollar edit--icon alignIconCenter tooltipitem tooltipitem__left"><span className="tooltipitemtext tooltipitemtext__left">Create a Proforma Invoice for this job</span></span>
                    </a>
                </div>
            </td>
            <td className="table__text--align table--col-xs">
                {item.itemStatusId != 8 && scheduleDayStatusId === 1 && item.allowDelete ?
                    <div className="delete--tablecell">
                        <a href="#" onClick={(e) => cancelItem(e, false, indexJob, item.itemIndex)}>
                            <span className="fas fa-times-circle edit--icon alignIconCenter makeitred tooltipitem tooltipitem__left"><span className="tooltipitemtext tooltipitemtext__left">Cancel Booking</span></span>
                        </a>
                    </div> : ""}
            </td>
        </tr>
    )
};


const ScheduleDayData = (props: ScheduleDayProps) => {
    const [loadingReckonData, setLoadingReckonData] = React.useState(false);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [showAddNew, setShowAddNew] = React.useState(false);
    const [showDayNotes, setShowDayNotes] = React.useState(false);
    const initEditDayNotes: EditNoteItem = {
        heading: "",
        rowIndex: 0,
        parentIndex: 0,
        id: 0,
        item: "",
        itemId: 0,
        notes: ""
    };
    const [editDayNotes, setEditDayNotes] = React.useState<EditNoteItem>(initEditDayNotes);
    const [jobOnly, setJobOnly] = React.useState(false);
    const [jobIndex, setJobIndex] = React.useState(-1);
    const [itemIndex, setItemIndex] = React.useState(-1);
    const [showNotes, setShowNotes] = React.useState(false);
    const [showCopy, setShowCopy] = React.useState(false);
    const [onOffhireDate, setOnOffhireDate] = React.useState("");
    const initCopyItem: CopyScheduleItem = {
        index: 0,
        scheduleId: 0,
        item: "",
        siteAddress: "",
        quantityScheduled: 0,
        qtyType: "",
        unitOfMeasure: "",
        isKwikstage: false,
        kwikstageItems: [],
        kwikstageOptions: []
    };
    const [copyItem, setCopyItem] = React.useState(initCopyItem);
    const [jobs, setJobs] = React.useState<JobItem[]>([]);
    const [kwikstageJobs, setKwikstageJobs] = React.useState<KwikstageJobItem[]>([]);
    const [showReschedule, setShowReschedule] = React.useState(false);
    const [showHoliday, setShowHoliday] = React.useState(false);
    const [showCancel, setShowCancel] = React.useState(false);
    const [cancelJobIndex, setCancelJobIndex] = React.useState(-1);
    const [cancelIndex, setCancelIndex] = React.useState(-1);
    const [showProformaInvoice, setShowProformaInvoice] = React.useState(false);
    const [showJobInfo, setShowJobInfo] = React.useState(false);
    const [showVoidGearList, setShowVoidGearList] = React.useState(false);
    const [scheduleId, setScheduleId] = React.useState(-1);
    const [jobQuoteItemId, setJobQuoteItemId] = React.useState(-1);
    const [showFlaggedJobs, setShowFlaggedJobs] = React.useState(false);
    const [dragStartIndex, setDragStartIndex] = React.useState(-1);
    const [dragEndIndex, setDragEndIndex] = React.useState(-1);

    const lock = () => {
        lockSchedule();
    }

    const lockSchedule = async () => {
        let scheduleDay = props.scheduleDay;
        let scheduledDate = scheduleDay.scheduledDate;
        let statusId = scheduleDay.statusId === 1 ? 2 : 1;
        let status = scheduleDay.statusId === 1 ? "Locked" : "Open";

        let schedule = {
            scheduleDate: scheduledDate,
            scheduleBranchId: props.scheduleBranchId,
            statusId: statusId
        };
        var jsonItem = JSON.stringify(schedule);
        const apiUrl = "LockSchedule";

        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error locking the scheduled day!");
        } else {
            toast.success("Scheduled Locked Successfully");
            scheduleDay.statusId = statusId;
            scheduleDay.status = status;

            props.updateScheduleDay(scheduledDate, scheduleDay);
        }
    }

    const handleChange = (e: any) => {
        var scheduleDay = props.scheduleDay;

        let change: any = scheduleDay;
        change[e.target.name] = e.target.value;

        props.updateScheduleDay(props.scheduleDay.scheduledDate, change);
    }

    const onCellChange = (e: any, jobLevelOnly: boolean, indexJob: number, indexItem: number) => {
        var scheduleDay = props.scheduleDay;
        var jobs = [...scheduleDay.jobs];
        var job = jobs[indexJob];
        job.isDirty = true;

        if (jobLevelOnly) {
            //job level
            let newItem: any = {};
            newItem = job;
            newItem[e.target.name] = e.target.value;
        } else {
            //job item level
            var item = job.items[indexItem];
            let newItem: any = {};
            newItem = item;
            newItem[e.target.name] = e.target.value;
            newItem.isDirty = true;
        }
        scheduleDay.jobs = jobs;
        props.updateScheduleDay(props.scheduleDay.scheduledDate, scheduleDay);
    }

    const onCellCheckboxChange = (e: any, jobOnly: boolean, indexJob: number, indexItem: number) => {
        var scheduleDay = props.scheduleDay;
        var jobs = [...scheduleDay.jobs];
        var job = jobs[indexJob];
        job.isDirty = true;

        if (jobOnly) {
            let newItem: any = {};
            newItem = job;
            newItem[e.target.name] = e.target.checked;
        } else {
            var item = job.items[indexItem];
            let newItem: any = {};
            newItem = item;
            newItem[e.target.name] = e.target.checked;
            newItem.isDirty = true;
        }

        props.updateScheduleDay(props.scheduleDay.scheduledDate, scheduleDay);
    }

    const onCellJobCheckboxChange = (e: any, indexJob: number) => {
        var scheduleDay = props.scheduleDay;
        var jobs = [...scheduleDay.jobs];
        var job = jobs[indexJob];
        job.isDirty = true;

        let newItem: any = {};
        newItem = job;
        newItem[e.target.name] = e.target.checked;

        //if job has items then update all the items
        if (job.totalItems > 0) {
            var items = job.items;
            for (var i = 0; i < items.length; i++) {
                let newJobItem: any = {};
                newJobItem = items[i];
                newJobItem[e.target.name] = e.target.checked;
            }
        }

        props.updateScheduleDay(props.scheduleDay.scheduledDate, scheduleDay);
    }

    const showItems = (e: any, indexJob: number, showItem: boolean) => {
        e.preventDefault();

        var scheduleDay = props.scheduleDay;
        var jobs = [...scheduleDay.jobs];
        var job = jobs[indexJob];
        job.showItems = showItem;

        props.updateScheduleDay(props.scheduleDay.scheduledDate, scheduleDay);
    }

    const showMap = () => {
        window.open("/schedulenew/map/1/" + props.scheduleDay.scheduledDate, "_blank");
    }

    const saveLimits = () => {
        saveDayLimits();
    }

    const saveDayLimits = async () => {
        var scheduleDay = props.scheduleDay;

        var limits = {
            scheduleDate: scheduleDay.scheduledDateActual,
            scheduleBranchId: props.scheduleBranchId,
            shortNotes: scheduleDay.shortNotes,
            walkWayGuardRailPitchMax: scheduleDay.walkWayGuardRailPitchMax,
            voidMax: scheduleDay.voidMax,
            kwikstageMax: scheduleDay.kwikstageMax
        };

        var jsonItem = JSON.stringify(limits);

        const apiUrl = "SaveDayLimits";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving day limits!");
        } else {
            toast.success("Schedule Limits saved");
        }
    }

    //DAY NOTES
    const showEditDayNotes = (e: any) => {
        e.preventDefault();

        var dayNotes: EditNoteItem = {
            id: 0,
            heading: "Edit Notes for " + props.scheduleDay.scheduledDateFormattedSmall,
            item: "",
            itemId: 0,
            parentIndex: 0,
            rowIndex: 0,
            notes: props.scheduleDay.notes
        };

        setShowDayNotes(true);
        setEditDayNotes(dayNotes);
    }

    const resetDayNote = () => {
        var dayNotes: EditNoteItem = {
            id: 0,
            heading: "",
            item: "",
            itemId: 0,
            parentIndex: 0,
            rowIndex: 0,
            notes: ""
        };
        return dayNotes;
    }

    const hideDayNotes = () => {
        var dayNotes = resetDayNote();
        setShowDayNotes(false);
        setEditDayNotes(dayNotes);
    }

    const updateDayNotes = (updatedItem: EditNoteItem) => {
        setEditDayNotes(prevState => ({ ...prevState, notes: updatedItem.notes  }));
    }

    const saveDayNotes = () => {
        dayNoteSave();
    }

    const dayNoteSave = async () => {
        let noteToSave = {
            scheduleDate: props.scheduleDay.scheduledDateActual,
            scheduleBranchId: props.scheduleBranchId,
            note: editDayNotes.notes
        };

        var jsonItem = JSON.stringify(noteToSave);

        const apiUrl = "SaveDayNote";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving notes!");
        } else {
            var dayNotes = resetDayNote();
            setShowDayNotes(false);
            setEditDayNotes(dayNotes);
            props.updateScheduleDay(props.scheduleDay.scheduledDate, props.scheduleDay);
            toast.success("Schedule Notes saved");
        }
    }

    //END DAY NOTES

    //HOLIDAY
    const hideHoliday = () => {
        setShowHoliday(false);
    }

    const saveHoliday = () => {
        setShowAddNew(true);
        setShowHoliday(false);
    }

    //END HOLIDAY

    //RECKON ACCOUNT BALANCE
    const getReckonBalance = () => {
        setLoadingReckonData(true);
        getReckonAccountBalance();
    }

    const getReckonAccountBalance = async () => {
        let scheduleJobs = props.scheduleDay;
        let dateToUpdate = scheduleJobs.scheduledDateActual;
        let accountBalanceJobs = scheduleJobs.jobs.filter(j => j.typeId === 1); //only need balance for installs

        var acctBalance = {
            customerAccountBalances: accountBalanceJobs
        };

        var jsonItem = JSON.stringify(acctBalance);

        const apiUrl = "GetReckonAccountBalance";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error getting Reckon account balance!");
        } else {
            var jobsWithAcctBalance = result.data;
            for (var i = 0; i < jobsWithAcctBalance.length; i++) {
                var item = jobsWithAcctBalance[i];
                var schedJobToUpdate = scheduleJobs.jobs.find(j => j.id == item.id);
                if (schedJobToUpdate) {
                    schedJobToUpdate.accountBalance = item.accountBalance;
                    schedJobToUpdate.accountBalanceFormatted = item.accountBalanceFormatted;
                    schedJobToUpdate.creditLimit = item.creditLimit;
                    schedJobToUpdate.remainingBalance = item.remainingBalance;
                    schedJobToUpdate.remainingBalanceFormatted = item.remainingBalanceFormatted;
                }
            }
            setLoadingReckonData(false);

            props.updateScheduleDay(dateToUpdate, scheduleJobs);
        }
    }
    //END RECKON ACCOUNT BALANCE

    //FLAGGED JOBS
    const showFlaggedJobItems = () => {
        setShowFlaggedJobs(true);
    }

    const hideFlaggedJobs = () => {
        setShowFlaggedJobs(false);
    }

    const saveFlaggedJobs = (datesToUpdate: string[]) => {
        for (var i = 0; i < datesToUpdate.length; i++) {
            var dateToUpdate = datesToUpdate[i];
            props.updateDay(dateToUpdate, true);
        }
        //update current day
        props.updateDay(props.scheduleDay.scheduledDate, true);
        setShowFlaggedJobs(false);
        toast.success("Jobs Scheduled");
    }

    const viewSearchDay = (scheduleDate: string, scheduleId: number) => {
        setShowFlaggedJobs(false);
        props.view(scheduleDate, scheduleId);
    }

    //END FLAGGED JOBS

    //ADD NEW
    const add = () => {
        var isPublicHol = props.publicHolidays.filter(ph => ph.date == props.scheduleDay.scheduledDateActual).length > 0;
        var isShutdown = false;
        if (!isPublicHol) {
            //only check shutdown periods if it isn't a public holiday
            for (var i = 0; i < props.shutdownPeriods.length; i++) {
                var dateIsShutdown = DateHelpers.dateBetweenDates(props.scheduleDay.scheduledDate, props.shutdownPeriods[i].startDate, props.shutdownPeriods[i].endDate);
                if (dateIsShutdown) {
                    //if the date is in one shutdown period we don't need to check the rest
                    isShutdown = dateIsShutdown;
                    break;
                }
            }
        }
        if (isPublicHol || isShutdown) {
            //show warning
            setShowHoliday(true);
        } else {
            setShowAddNew(true);
        }
    }

    const hideAddNew = () => {
        setShowAddNew(false);
    }

    const saveAddNew = (items: AddNewResults[]) => {
        addScheduleItem(items);
    }

    const addScheduleItem = async (items: AddNewResults[]) => {
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            //need to cater for null dates
            item.bringForwardDate = item.bringForwardDate === "" ? null : item.bringForwardDate;
            item.pickupDate = item.pickupDate === "" ? null : item.pickupDate;
            item.endhireDate = item.endhireDate === "" ? null : item.endhireDate;
        }

        var schedule = {
            scheduleDate: props.scheduleDay.scheduledDate,
            scheduleBranchId: props.scheduleBranchId,
            tiltTruckScheduler: false,
            scheduleItems: items
        };

        var jsonItem = JSON.stringify(schedule);

        const apiUrl = "SaveAddNewScheduleItems";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving schedule!");
        } else {
            //reload the day
            toast.success("Schedule Saved");
            setShowAddNew(false);
            //update the other days that have had jobs moved
            var dates = result.data;
            for (var i = 0; i < dates.length; i++) {
                var dateToUpdate = dates[i];
                props.updateDay(dateToUpdate, true);
            }
            //update current day
            props.updateDay(props.scheduleDay.scheduledDate, true);
        }
    }

    const saveManualJob = (newManualJob: NewManualItem) => {
        saveManualItem(newManualJob);
    }

    const saveManualItem = async (newManualJob: NewManualItem) => {
        newManualJob.scheduleBranchId = props.scheduleBranchId;

        var jsonItem = JSON.stringify(newManualJob);

        const apiUrl = "SaveNewAllocationItem";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving item!");
        } else {
            toast.success("Schedule Saved");
            setShowAddNew(false);
            props.updateDay(props.scheduleDay.scheduledDate, true);
        }
    }
    //END ADD NEW

    //COPY
    const copyItemJob = (e: any, jobOnly: boolean, indexJob: number, indexItem: number) => {
        e.preventDefault();

        //check if any items have changed
        let itemsChanged = props.scheduleDay.jobs.filter(x => x.isDirty);
        if (itemsChanged.length > 0) {
            if (validate()) {
                props.saveDay(props.scheduleDay.scheduledDate);
                showCopyItem(jobOnly, indexJob, indexItem);
            }
        } else {
            showCopyItem(jobOnly, indexJob, indexItem);
        }    
    }

    const showCopyItem = (jobOnly: boolean, indexJob: number, indexItem: number) => {
        var schedJobs = props.scheduleDay.jobs;
        var job = schedJobs[indexJob];

        if (jobOnly) {
            if (job.itemIsKwikstage) {
                copyJobItem(jobOnly, indexJob, indexItem);
            } else {
                var copyDetails: CopyScheduleItem = {
                    index: indexJob,
                    scheduleId: job.id,
                    siteAddress: job.siteAddress,
                    item: job.item,
                    quantityScheduled: job.quantityScheduled,
                    qtyType: job.quantityType,
                    unitOfMeasure: job.unitOfMeasure,
                    isKwikstage: false,
                    kwikstageItems: [],
                    kwikstageOptions: []
                };

                let jobItems: JobItem[] = [];
                let jobItem: JobItem = {
                    itemIndex: 0,
                    quantity: 0,
                    scheduleDate: "",
                    warning: false,
                    locked: false
                };
                jobItems.push(jobItem);

                setOnOffhireDate(job.onOffhireDate);
                setJobs(jobItems);
                setKwikstageJobs([]);
                setShowCopy(true);
                setCopyItem(copyDetails);
            }
        } else {
            var itemToCopy = job.items[indexItem];

            if (itemToCopy.itemIsKwikstage) {
                copyJobItem(jobOnly, indexJob, indexItem);
            } else {
                var copyDetails: CopyScheduleItem = {
                    index: indexItem,
                    scheduleId: itemToCopy.id,
                    siteAddress: itemToCopy.siteAddress,
                    item: itemToCopy.item,
                    quantityScheduled: itemToCopy.quantityScheduled,
                    qtyType: itemToCopy.quantityType,
                    unitOfMeasure: itemToCopy.unitOfMeasure,
                    isKwikstage: false,
                    kwikstageItems: [],
                    kwikstageOptions: []
                };

                let jobItems: JobItem[] = [];
                let jobItem: JobItem = {
                    itemIndex: 0,
                    quantity: 0,
                    scheduleDate: "",
                    warning: false,
                    locked: false
                };
                jobItems.push(jobItem);
                setOnOffhireDate(itemToCopy.onOffhireDate);
                setJobs(jobItems);
                setKwikstageJobs([]);
                setShowCopy(true);
                setCopyItem(copyDetails);
            }
        }
    }

    const copyJobItem = async (jobOnly: boolean, indexJob: number, indexItem: number) => {
        var schedJobs = props.scheduleDay.jobs;
        var job = schedJobs[indexJob];
        let itemToCopy = jobOnly ? job : job.items[indexItem];

        const apiUrl = "GetKwikstageRolloverDetails?ScheduleId=" + itemToCopy.id;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting item details!");
        } else {
            var ksItems = result.data.kwikstageRolloverItems;
            var ksOptions = result.data.kwikstageOptions;
            var totalBays = result.data.totalBays;

            var copyDetails: CopyScheduleItem = {
                index: jobOnly ? indexJob : indexItem,
                scheduleId: itemToCopy.id,
                siteAddress: itemToCopy.siteAddress,
                item: itemToCopy.item,
                quantityScheduled: totalBays,
                qtyType: itemToCopy.quantityType,
                unitOfMeasure: itemToCopy.unitOfMeasure,
                isKwikstage: itemToCopy.itemIsKwikstage,
                kwikstageItems: ksItems,
                kwikstageOptions: ksOptions
            };

            setOnOffhireDate(itemToCopy.onOffhireDate);
            setKwikstageJobs(result.data.kwikstageJobs);
            setJobs([]);
            setShowCopy(true);
            setCopyItem(copyDetails);
        } 
    }

    const hideCopy = () => {
        var copyDetails = resetCopyItem();
        setShowCopy(false);
        setCopyItem(copyDetails);
    }

    const resetCopyItem = () => {
        var item: CopyScheduleItem = {
            index: 0,
            scheduleId: 0,
            siteAddress: "",
            item: "",
            quantityScheduled: 0,
            qtyType: "",
            unitOfMeasure: "",
            isKwikstage: false,
            kwikstageItems: [],
            kwikstageOptions: []
        };
        return item;
    }

    const updateOnOffHireDate = (updatedOnOffHireDate: string) => {
        setOnOffhireDate(updatedOnOffHireDate);
    }

    const updateCopyJobs = (updatedJobItems: JobItem[]) => {
        setJobs(updatedJobItems);
    }

    const updateCopyKwikstageJobs = (updatedKwikstageJobs: KwikstageJobItem[]) => {
        setKwikstageJobs(updatedKwikstageJobs);
    }

    const saveCopyItem = (itemToSave: SaveItem) => {
        props.updateDay(props.scheduleDay.scheduledDate, true);

        //update the other days from the copied schedule
        for (var i = 0; i < itemToSave.dates.length; i++) {
            var dateToUpdate = itemToSave.dates[i];
            props.updateDay(dateToUpdate, true);
        }

        var copyDetails = resetCopyItem();
        setShowCopy(false);
        setCopyItem(copyDetails);
    }

    //END COPY

    //RESCHEDULE
    const rescheduleItem = (e: any, jobOnly: boolean, indexJob: number, indexItem: number) => {
        e.preventDefault();

        //check if any items have changed
        let itemsChanged = props.scheduleDay.jobs.filter(x => x.isDirty);
        if (itemsChanged.length > 0) {
            if (validate()) {
                props.saveDay(props.scheduleDay.scheduledDate);
                showRescheduleItem(jobOnly, indexJob, indexItem);
            }
        } else {
            showRescheduleItem(jobOnly, indexJob, indexItem);
        }
    }

    const showRescheduleItem = (jobOnly: boolean, indexJob: number, indexItem: number) => {
        var schedJobs = props.scheduleDay.jobs;
        var job = schedJobs[indexJob];

        if (jobOnly) {
            setShowReschedule(true);
            setScheduleId(job.id);
        } else {
            var items = job.items;
            var itemToMove = items[indexItem];
            setShowReschedule(true);
            setScheduleId(itemToMove.id);
        }
    }

    const hideReschedule = () => {
        setShowReschedule(false);
        setScheduleId(-1);
    }

    const saveRescheduleItem = (scheduleDateNew: string) => {
        //item has been saved but need to move the original item
        props.updateDay(props.scheduleDay.scheduledDate, true);
        props.updateDay(scheduleDateNew, true);
        setShowReschedule(false);
        setScheduleId(-1);
    }
    //END RESCHEDULE

    //CANCEL
    const cancelItem = (e: any, jobOnly: boolean, indexJob: number, indexItem: number) => {
        e.preventDefault();
        checkCancelItem(jobOnly, indexJob, indexItem);
    }

    const checkCancelItem = async (jobLevelOnly: boolean, indexJob: number, indexItem: number) => {
        var schedDay = props.scheduleDay;
        var schedJobs = schedDay.jobs;
        var job = schedJobs[indexJob];
        let jobId = job.jobId;
        let schType = job.typeId;
        let itemId = job.itemId;

        if (!jobLevelOnly) {
            var items = job.items;
            var itemToRemove = items[indexItem];
            jobId = itemToRemove.jobId;
            schType = itemToRemove.typeId;
            itemId = itemToRemove.itemId;
        }

        const apiUrl = "CheckCancelJob?JobId=" + jobId + '&itemId=' + itemId + '&ScheduleType=' + schType;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error checking job to cancel!");
        } else {
            var canCancel = result.data;
            let errorList: any = {};

            if (canCancel) {
                setShowCancel(true);
                setJobOnly(jobLevelOnly)
                setCancelJobIndex(indexJob);
                setCancelIndex(indexItem);
            } else {
                toast.error("Cannot cancel pickup job as customer cannot go into Overhire. Use Extend via Allocate screen instead.");
                errorList["scheduleItems"] = "Cannot cancel pickup job as customer cannot go into Overhire. Use Extend via Allocate screen instead.";
                setErrors(errorList);
            }
        } 
    }

    const hideCancel = () => {
        setShowCancel(false);
        setJobOnly(false);
        setCancelJobIndex(-1);
        setCancelIndex(-1);
    }

    const saveCancel = () => {
        saveCancelItem();
    }

    const saveCancelItem = async () => {
        var schedDay = props.scheduleDay;
        var schedJobs = schedDay.jobs;
        var job = schedJobs[cancelJobIndex];
        
        var scheduleId = job.id;

        if (!jobOnly) {
            var items = job.items;
            var itemToRemove = items[cancelIndex];
            scheduleId = itemToRemove.id;
        }

        const apiUrl = "DeleteScheduleItem?ScheduleId=" + scheduleId;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error deleting item!");
        } else {
            setShowCancel(false);
            setJobOnly(false);
            setCancelJobIndex(-1);
            setCancelIndex(-1);
            props.updateDay(props.scheduleDay.scheduledDate, true);

            //check if there is another date to update - happens if we rollover a job
            var dateToUpdate = result.data.dateToRefresh;
            if (dateToUpdate != "") {
                props.updateDay(dateToUpdate, true);
            }

            toast.success("Item has been unscheduled");
        } 
    }

    //END CANCEL

    //INVOICE JOB
    const invoiceJob = (e: any, jobOnly: boolean, indexJob: number, indexItem: number) => {
        e.preventDefault();
        setShowProformaInvoice(true);
        setJobOnly(jobOnly);
        setCancelJobIndex(indexJob);
        setCancelIndex(indexItem);
    }

    const hideProformaInvoice = () => {
        setShowProformaInvoice(false);
        setJobOnly(false);
        setCancelJobIndex(-1);
        setCancelIndex(-1);
    }

    const saveProformaInvoice = () => {
        saveInvoice();
    }
    const saveInvoice = async () => {
        var scheduleDay = props.scheduleDay;
        var schedJobs = scheduleDay.jobs;
        var job = schedJobs[cancelJobIndex];

        //if they click on a job there could be multiple items to create an invoice for
        var scheduleIds: number[] = [];

        if (!jobOnly) {
            var items = job.items;
            var item = items[cancelIndex]
            item.allowInvoice = false;
            item.allowDelete = false;
            //only one job selected
            scheduleIds.push(item.id);
        } else {
            //check if there are items on the job and add them all
            var items = job.items;
            if (items.length > 0) {
                for (var i = 0; i < items.length; i++) {
                    scheduleIds.push(items[i].id);
                    items[i].allowInvoice = false;
                    items[i].allowDelete = false;
                }
            } else {
                //just add the one job schedule id
                job.allowInvoice = false;
                job.allowDelete = false;
                scheduleIds.push(job.id);
            }
        }

        var data = {
            scheduleIds: scheduleIds,
            jobId: job.jobId
        };

        var jsonItem = JSON.stringify(data);

        const apiUrl = "CreateProformaInvoice";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error creating proforma invoice!");
        } else {
            toast.success("Proforma Invoice Created Successfully");
            setShowProformaInvoice(false);
            setJobOnly(false);
            setCancelJobIndex(-1);
            setCancelIndex(-1);

            props.updateDay(props.scheduleDay.scheduledDate, true);
        }
    }

    //END INVOICE JOB

    //NOTES
    const editNotes = (e: any, jobLevelOnly: boolean, indexJob: number, indexItem: number) => {
        e.preventDefault();

        var scheduleDay = props.scheduleDay;
        var scheduleJobs = scheduleDay.jobs;
        var scheduleJob = scheduleJobs[indexJob];
        var scheduleId = -1;

        if (jobLevelOnly) {
            scheduleId = scheduleJob.id;
        } else {
            var scheduleItems = scheduleJob.items;
            var scheduleItem = scheduleItems[indexItem];
            scheduleId = scheduleItem.id;   
        } 

        setJobOnly(jobLevelOnly);
        setScheduleId(scheduleId);
        setJobIndex(indexJob);
        setItemIndex(indexItem);
        setShowNotes(true);
    }

    const hideNotesModal = () => {
        setShowNotes(false);
        setJobOnly(false);
        setScheduleId(-1);
        setJobIndex(-1);
        setItemIndex(-1);
        setErrors({});
    }

    const saveNotes = (scheduleNotes: string, timestamp: Uint8Array) => {
        var scheduleDay = props.scheduleDay;
        var scheduleJobs = scheduleDay.jobs;
        var scheduleJob = scheduleJobs[jobIndex];

        if (jobOnly) {
            scheduleJob.scheduleNotes = scheduleNotes;
            scheduleJob.rowVersionTimestamp = timestamp;
            scheduleJob.showGreenNotes = scheduleNotes.length > 0;
        } else {
            var scheduleItems = scheduleJob.items;
            var scheduleItem = scheduleItems[itemIndex];
            scheduleItem.scheduleNotes = scheduleNotes;
            scheduleItem.rowVersionTimestamp = timestamp;
            scheduleItem.showGreenNotes = scheduleNotes.length > 0;
        }

        setShowNotes(false);
        setJobOnly(false);
        setScheduleId(-1);
        setJobIndex(-1);
        setItemIndex(-1);
        setErrors({});

        props.updateScheduleDay(props.scheduleDay.scheduledDate, scheduleDay);
    }

    //END NOTES

    //SHOW INFO
    const showInfo = (e: any, jobOnly: boolean, indexJob: number, indexItem: number) => {
        e.preventDefault();

        //check if any items have changed
        let itemsChanged = props.scheduleDay.jobs.filter(x => x.isDirty);
        if (itemsChanged.length > 0) {
            if (validate()) {
                props.saveDay(props.scheduleDay.scheduledDate);
                showInfoModal(jobOnly, indexJob, indexItem);
            }
        } else {
            showInfoModal(jobOnly, indexJob, indexItem);
        }
    }

    const showInfoModal = (jobOnly: boolean, indexJob: number, indexItem: number) => {
        getJobInfo(jobOnly, indexJob, indexItem);
    }

    const getJobInfo = (jobOnly: boolean, indexJob: number, indexItem: number) => {
        var schedule = jobOnly ? props.scheduleDay.jobs[indexJob] : props.scheduleDay.jobs[indexJob].items[indexItem];
        setShowJobInfo(true);
        setJobOnly(jobOnly);
        setJobIndex(indexJob);
        setItemIndex(indexItem);
        setScheduleId(schedule.id);
    }

    const hideJobInfo = () => {
        setShowJobInfo(false);
        setJobOnly(false);
        setJobIndex(-1);
        setItemIndex(-1);
        setScheduleId(-1);
        setJobQuoteItemId(-1);
    }

    const openGearlist = () => {
        var schedule = jobOnly ? props.scheduleDay.jobs[jobIndex] : props.scheduleDay.jobs[jobIndex].items[itemIndex];
        setShowJobInfo(false);
        setShowVoidGearList(true);
        setJobQuoteItemId(schedule.jobQuoteItemId);
    }

    const saveJobInfo = () => {
        setShowJobInfo(false);
        setJobOnly(false);
        setJobIndex(-1);
        setItemIndex(-1);
        setScheduleId(-1);
        setJobQuoteItemId(-1);
        props.updateDay(props.scheduleDay.scheduledDate, true);
    }
    //END SHOW INFO

    //VOID GEAR LIST
    const hideVoidGearList = () => {
        setShowVoidGearList(false);
        setShowJobInfo(true);
        setJobQuoteItemId(-1);
    }

    const saveVoidGearList = () => {
        setShowVoidGearList(false);
        setShowJobInfo(true);
        setJobQuoteItemId(-1);
    }
    //END VOID GEARLIST

    const refreshDay = () => {
        setErrors({});
        props.updateDay(props.scheduleDay.scheduledDate, true);
    }

    const onDragStart = (index: number) => {
        setDragStartIndex(index);
    }

    const onDragEnter = (index: number) => {
        setDragEndIndex(index);
    }

    const onDragEnd = (e: any) => {
        e.preventDefault();

        var scheduleDay = props.scheduleDay;
        var schedJobs = scheduleDay.jobs;

        if (dragStartIndex != dragEndIndex) {
            schedJobs.splice(dragEndIndex, 0, schedJobs.splice(dragStartIndex, 1)[0]);
            var items: ItemOrder[] = [];
            var jobOrder = 1;
            //loop through the items and update the order
            for (var j = 0; j < schedJobs.length; j++) {
                let job = schedJobs[j];
                job.itemIndex = j;
                if (job.totalItems === 0) {
                    job.jobOrder = jobOrder;
                    job.jobIndex = jobOrder;

                    let itemOrder: ItemOrder = {
                        scheduleId: job.id,
                        jobOrder: jobOrder,
                        rowVersionTimestamp: job.rowVersionTimestamp
                    };
                    items.push(itemOrder);
                    jobOrder += 1;
                } else {
                    job.jobIndex = jobOrder; //not used but can't be null
                    for (var i = 0; i < job.items.length; i++) {
                        let item = job.items[i];
                        item.itemIndex = i;
                        item.jobOrder = jobOrder;
                        item.jobIndex = jobOrder;
                        jobOrder += 1;

                        let itemOrder: ItemOrder = {
                            scheduleId: item.id,
                            jobOrder: item.jobOrder,
                            rowVersionTimestamp: item.rowVersionTimestamp
                        };
                        items.push(itemOrder);
                    }
                }
            }

            //props.updateDay(props.scheduleDay.scheduledDate, true);
            props.saveDayOrder(props.scheduleDay.scheduledDate, items);
        }

        setDragStartIndex(-1);
        setDragEndIndex(-1);
    }

    //private onSortEnd = ({ oldIndex, newIndex }: { oldIndex: number, newIndex: number }) => {
    //    var scheduleDay = this.props.scheduleDay;
    //    var schedJobs = scheduleDay.jobs;

    //    if (oldIndex != newIndex) {
    //        schedJobs.splice(newIndex, 0, schedJobs.splice(oldIndex, 1)[0]);

    //        var items: ItemOrder[] = [];
    //        var jobOrder = 1;
    //        //loop through the items and update the order
    //        for (var j = 0; j < schedJobs.length; j++) {
    //            let job = schedJobs[j];
    //            job.itemIndex = j;
    //            if (job.totalItems === 0) {
    //                job.jobOrder = jobOrder;
    //                job.jobIndex = jobOrder;

    //                let itemOrder: ItemOrder = {
    //                    scheduleId: job.id,
    //                    jobOrder: jobOrder,
    //                    rowVersionTimestamp: job.rowVersionTimestamp
    //                };
    //                items.push(itemOrder);
    //                jobOrder += 1;
    //            } else {
    //                job.jobIndex = jobOrder; //not used but can't be null
    //                for (var i = 0; i < job.items.length; i++) {
    //                    let item = job.items[i];
    //                    item.itemIndex = i;
    //                    item.jobOrder = jobOrder;
    //                    item.jobIndex = jobOrder;
    //                    jobOrder += 1;

    //                    let itemOrder: ItemOrder = {
    //                        scheduleId: item.id,
    //                        jobOrder: item.jobOrder,
    //                        rowVersionTimestamp: item.rowVersionTimestamp
    //                    };
    //                    items.push(itemOrder);
    //                }
    //            }
    //        }

    //        this.props.updateScheduleDay(this.props.scheduleDay.scheduledDate, scheduleDay);
    //        this.props.saveDayOrder(this.props.scheduleDay.scheduledDate, items);
    //    }
    //};

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        //only validate items that have changed as those are the ones we are saving
        let scheduleDay = props.scheduleDay;
        var allItems = scheduleDay.jobs;
        let schedJobs = allItems.filter(x => x.isDirty);

        var errorString = "Please enter the following values: ";
        var error = false;
        var updateItems = false;

        for (var i = 0; i < schedJobs.length; i++) {
            var job = schedJobs[i];
            //if there are no sub items then validate the job
            if (job.items.length === 0) {
                var jobErrorString = "";
                //only validate items that are not manual items
                if (!job.manualItem) {
                    if (job.typeId === 1) {
                        if (job.onOffhireDate == "") {
                            jobErrorString += " Onhire Date, ";
                            error = true;
                        } else if (!DateHelpers.isValidDate(job.onOffhireDate)) {
                            jobErrorString += " Valid Onhire Date, ";
                            error = true;
                        } else if (!DateHelpers.compareDate(props.scheduleDay.scheduledDate, job.onOffhireDate)) {
                            //check to make sure offhire date is before or equal to pickup date
                            jobErrorString += " Onhire Date must be >= Installation Date, ";
                            error = true;
                        }
                    } else {
                        if (job.onOffhireDate == "") {
                            jobErrorString += " Offhire Date, ";
                            error = true;
                        } else if (!DateHelpers.isValidDate(job.onOffhireDate)) {
                            jobErrorString += " Valid Offhire Date, ";
                            error = true;
                        } else if (!DateHelpers.compareDate(job.onOffhireDate, props.scheduleDay.scheduledDate)) {
                            //check to make sure offhire date is before or equal to pickup date
                            jobErrorString += " Offhire Date must be <= Dismantle Date, ";
                            error = true;
                        }
                    }
                }

                if (jobErrorString != "") {
                    errorString += "\n"
                    errorString += "Row " + (job.jobOrder) + ": " + jobErrorString;
                    errorString = errorString.substring(0, errorString.length - 2);
                }
            }

            for (var x = 0; x < job.items.length; x++) {
                var item = job.items[x];
                var newErrorString = "";

                //only validate items that are not manual items
                if (!item.manualItem) {
                    if (item.typeId === 1) {
                        if (item.onOffhireDate == "") {
                            newErrorString += " Onhire Date, ";
                            error = true;
                        } else if (!DateHelpers.isValidDate(item.onOffhireDate)) {
                            newErrorString += " Valid Onhire Date, ";
                            error = true;
                        } else if (!DateHelpers.compareDate(props.scheduleDay.scheduledDate, item.onOffhireDate)) {
                            //check to make sure offhire date is before or equal to pickup date
                            newErrorString += " Onhire Date must be >= Installation Date, ";
                            error = true;
                        }

                        //only check p/o if job is ready for allocating
                        if (item.accountTypeId == 3 && !item.purchaseOrderNumber.trim() && item.accountChecked && item.goAhead) {
                            newErrorString += " Purchase Order Number, ";
                            error = true;
                            item.goAhead = false;
                            updateItems = true;
                        }
                    } else {
                        if (item.onOffhireDate == "") {
                            newErrorString += " Offhire Date, ";
                            error = true;
                        } else if (!DateHelpers.isValidDate(item.onOffhireDate)) {
                            newErrorString += " Valid Offhire Date, ";
                            error = true;
                        } else if (!DateHelpers.compareDate(item.onOffhireDate, props.scheduleDay.scheduledDate)) {
                            //check to make sure offhire date is before or equal to pickup date
                            newErrorString += " Offhire Date must be <= Dismantle Date, ";
                            error = true;
                        }
                    }
                }

                if (newErrorString != "") {
                    errorString += "\n"
                    errorString += "Row " + (item.jobOrder) + ": " + newErrorString;
                    errorString = errorString.substring(0, errorString.length - 2);
                }
            }
        }
        if (error) {
            formIsValid = false;
            errorList["scheduleItems"] = errorString;
        }

        if (updateItems) {
            props.updateScheduleDay(props.scheduleDay.scheduledDate, scheduleDay);
        }
        
        setErrors(errorList);
        return formIsValid;
    }

    const save = () => {
        //validation
        if (validate()) {
            props.saveDay(props.scheduleDay.scheduledDate);
        } else {
            toast.error("Please fix validation errors and try Saving again!");
        }
    }

    var minDate = props.allowAllocateToPastDate ? DateHelpers.addDaysToCurrentDate(-90) : (props.scheduleDay.scheduledDate < DateHelpers.addDaysToCurrentDate(-2)) ? props.scheduleDay.scheduledDate : DateHelpers.addDaysToCurrentDate(-2);
    var buttonText = props.scheduleDay.statusId == 1 ? "Lock" : "Unlock";
    let notesPopup = <NotesPopup showEditNotesModal={showDayNotes} editNotes={editDayNotes} hideNotes={hideDayNotes} updateNotes={updateDayNotes} saveNotes={saveDayNotes} />;
    let addNewSchedule = <AddNewScheduleData scheduleDate={props.scheduleDay.scheduledDate} dateFormatted={props.scheduleDay.scheduledDateFormatted} scheduleTypes={props.scheduleTypes} showModal={showAddNew} hideModal={hideAddNew} save={saveAddNew} saveManual={saveManualJob} />
    var notes = <EditNoteModal systemCompanyId={2} scheduleId={scheduleId} editDriverNotes={false} showDriverScheduleNotes={false} showEditNotesModal={showNotes} save={saveNotes} hideModal={hideNotesModal} />
    let copyJob = <CopyJobData onOffhireDate={onOffhireDate} scheduleBranchId={props.scheduleBranchId} jobs={jobs} kwikstageJobs={kwikstageJobs} showModal={showCopy} hideModal={hideCopy} copyItem={copyItem} updateOnOffHireDate={updateOnOffHireDate} updateJobs={updateCopyJobs} updateKwikstageJobs={updateCopyKwikstageJobs} saveModal={saveCopyItem} />
    let rescheduleJob = <RescheduleJobData publicHolidays={props.publicHolidays} shutdownPeriods={props.shutdownPeriods} reasonOptions={props.reasonOptions} showModal={showReschedule} hideModal={hideReschedule} scheduleId={scheduleId} saveModal={saveRescheduleItem} />
    let jobInfo = <JobInfoData systemCompanyId={2} scheduleId={scheduleId} showModal={showJobInfo} hideModal={hideJobInfo} openGearlist={openGearlist} saveModal={saveJobInfo} />
    let editVoidGearlist = <JobScheduleVoidModalData showModal={showVoidGearList} jobQuoteItemId={jobQuoteItemId} hideModal={hideVoidGearList} saveModal={saveVoidGearList} />
    let flaggedJobs = <FlaggedJobsData scheduleDate={props.scheduleDay.scheduledDate} dateFormatted={props.scheduleDay.scheduledDateFormatted} systemCompanyId={2} scheduleBranchId={props.scheduleBranchId} showModal={showFlaggedJobs} hideModal={hideFlaggedJobs} save={saveFlaggedJobs} filterDate={viewSearchDay} />
    let confirmHolPeriod = <ConfirmPopups heading="Public Holiday / Shutdown Period" text="Are you sure you want to add a job to a Public Holiday / Shutdown Period?" showConfirmModal={showHoliday} hideConfirmModal={hideHoliday} saveConfirmModal={saveHoliday} />
    let confirmCancel = <ConfirmPopups heading="Cancel Job" text="Are you sure you want to cancel this job?" showConfirmModal={showCancel} hideConfirmModal={hideCancel} saveConfirmModal={saveCancel} />
    let confirmInvoice = <ConfirmPopups heading="Create Proforma Invoice" text="Are you sure you want to create a proforma invoice for this job?" showConfirmModal={showProformaInvoice} hideConfirmModal={hideProformaInvoice} saveConfirmModal={saveProformaInvoice} />
    let showWarningBooked = props.scheduleDay.walkWayGuardRailPitchMaxRemaining + props.scheduleDay.voidMaxRemaining + props.scheduleDay.kwikstageMaxRemaining <= 0;
    let showWarningDayClose = props.scheduleDay.walkWayGuardRailPitchMaxRemaining < WalkWayGuardRailPitchWarningNo && props.scheduleDay.voidMaxRemaining < VoidWarningNo && props.scheduleDay.kwikstageMaxRemaining < KwikstageWarningNo;
    let warningText = showWarningBooked ? "Warning: Day booked out" : showWarningDayClose ? "Warning: Day close to being booked out" : "";
    let walkWayClass = props.scheduleDay.walkWayGuardRailPitchMaxRemaining <= 0 ? " makeitred makeitbold" : props.scheduleDay.walkWayGuardRailPitchMaxRemaining > 0 && props.scheduleDay.walkWayGuardRailPitchMaxRemaining < WalkWayGuardRailPitchWarningNo ? " makeitorange makeitbold" : "";
    let voidClass = props.scheduleDay.voidMaxRemaining <= 0 ? " makeitred makeitbold" : props.scheduleDay.voidMaxRemaining > 0 && props.scheduleDay.voidMaxRemaining < VoidWarningNo ? " makeitorange makeitbold" : "";
    let KwikstageClass = props.scheduleDay.kwikstageMaxRemaining <= 0 ? " makeitred makeitbold" : props.scheduleDay.kwikstageMaxRemaining > 0 && props.scheduleDay.kwikstageMaxRemaining < KwikstageWarningNo ? " makeitorange makeitbold" : "";

    const contents = (
        <div className="schedulenew__day--marginside">
            <div>
                {notesPopup}
                {confirmHolPeriod}
                {confirmCancel}
                {confirmInvoice}
                {addNewSchedule}
                {copyJob}
                {rescheduleJob}
                {jobInfo}
                {editVoidGearlist}
                {flaggedJobs}
                {notes}
            </div>
            <div className="schedulenew__statusBar">
                <div>
                    <span className="schedulenew__day marginRight10">{props.scheduleDay.scheduledDateFormatted}</span>
                    <span className="marginLeft10">
                        <a className={props.scheduleDay.notes && props.scheduleDay.notes.length > 0 ? "makeitred" : ""} href="#" onClick={(e) => showEditDayNotes(e)}>
                            <span className="fas fa-pencil-alt edit--icon"></span>
                        </a>
                    </span>
                </div>
                <div><span className={props.scheduleDay.statusId === 1 ? "schedulenew__day" : "schedulenew__day makeitred"}>{props.scheduleDay.status}</span></div>
                <div>
                    <button className="defaultbutton defaultbutton__small--height marginLeft10" type='button' title="Refreshes the current day" onClick={refreshDay}>Refresh</button>
                    <button className={props.allowLock ? "defaultbutton defaultbutton__small--height marginLeft10" : "hidden"} type='button' title="Locks the current day so you cannot add or modify any jobs" onClick={lock}>{buttonText}</button>
                    <button className="defaultbutton defaultbutton__small--height marginLeft10" type='button' title="Shows the jobs on google maps" onClick={showMap}>Map</button>
                    <button className={props.allowGetAccountBalance ? "defaultbutton defaultbutton__medium--height marginLeft10" : "hidden"} type='button' title="Get customer account balance from Reckon" onClick={getReckonBalance}>Balance Check</button>
                    <button className="defaultbutton defaultbutton__small--height marginLeft10" type='button' title="Show all jobs with a bring forward date of today or earlier with a scheduled date > today" onClick={showFlaggedJobItems} disabled={props.scheduleDay.statusId === 2}>Flagged</button>
                    <button className="defaultbutton defaultbutton__small--height marginLeft10" type='button' title="Allows user to add an existing quoted job, dismantle or manual job to the current day" onClick={add} disabled={props.scheduleDay.statusId === 2}>Add New</button>
                    <button className="defaultbutton defaultbutton__medium--height defaultbutton--green marginLeft10" type='button' onClick={save} disabled={props.scheduleDay.statusId === 2}>Save</button>
                </div>
            </div>
            <div className="schedulenew__statusBar">
                <div>
                    <label htmlFor="walkWayGuardRailPitchMax">
                        <span className="label label__right-padding">WW</span>
                        <input className="input input--xsmall marginRight10" type='number' id="walkWayGuardRailPitchMax" name="walkWayGuardRailPitchMax" value={props.scheduleDay.walkWayGuardRailPitchMax} onChange={(e) => handleChange(e)} disabled={!props.allowUpdateDayLimits}></input>
                        <span className={"label label__right-padding" + walkWayClass}>{props.scheduleDay.walkWayGuardRailPitchMaxRemaining}</span>
                    </label>
                    <label htmlFor="voidMax">
                        <span className="label label__right-padding">V</span>
                        <input className="input input--xsmall marginRight10" type='number' id="voidMax" name="voidMax" value={props.scheduleDay.voidMax} onChange={(e) => handleChange(e)} disabled={!props.allowUpdateDayLimits}></input>
                        <span className={"label label__right-padding" + voidClass}>{props.scheduleDay.voidMaxRemaining}</span>
                    </label>
                    <label htmlFor="kwikstageMax">
                        <span className="label label__right-padding">KS</span>
                        <input className="input input--xsmall marginRight10" type='number' id="kwikstageMax" name="kwikstageMax" value={props.scheduleDay.kwikstageMax} onChange={(e) => handleChange(e)} disabled={!props.allowUpdateDayLimits}></input>
                        <span className={"label label__right-padding" + KwikstageClass}>{props.scheduleDay.kwikstageMaxRemaining}</span>
                    </label>
                    <label htmlFor="shortNotes">
                        <input type='text' maxLength={200} id="shortNotes" name="shortNotes" className='input schedule__shortNote--size marginRight10' value={props.scheduleDay.shortNotes} onChange={(e) => handleChange(e)}></input>
                    </label>
                    <button className="defaultbutton defaultbutton__xsmall--height marginLeft10" type='button' title="Saves job limits for the day" onClick={saveLimits} disabled={props.scheduleDay.statusId === 2}>Save</button>
                </div>
                <div className="alignitemsbottom">
                    <div className={showWarningBooked ? "colAlignSplit warning-bkg--red paddingLeft10" : showWarningDayClose ? "colAlignSplit warning-bkg--orange paddingLeft10" : "colAlignSplit schedulewarning paddingLeft10"}>
                        <div>
                            <span className="warning-text">{warningText}</span>
                        </div>
                        <div>
                            <span>Light Duty Time: {props.scheduleDay.lightDutyMins}</span>
                            <span className="marginLeft10">Void Time: {props.scheduleDay.voidMins}</span>
                            <span className="marginLeft10">Kwikstage Total: {props.scheduleDay.kwikstageTotal}</span>
                        </div>
                        <div><span>Day Total: {props.scheduleDay.dayAmountFormatted}</span></div>
                    </div>
                </div>

            </div>
                
            <div className={props.loadingDay || loadingReckonData ? "schedulenew-loadDay" : "hidden"}>
                <h2>{props.loadingDay ? "Loading..." : "Retrieving Reckon Account Balances..."}</h2>
            </div>
            <div className={props.loadingDay || loadingReckonData ? "hidden" : ""}>
                <div className="overflowAuto tableColours-header marginTop10">
                    <table className="table table__extralarge">
                        <thead>
                            <tr>
                                <th className="hidden"></th>
                                <th className="table--col-xs"></th>
                                <th className="table--col-xs"></th>
                                <th className="table--col-s">
                                    <div className="tooltipitem tooltipitem__right">Order
                                        <span className="tooltipitemtext tooltipitemtext__right">Temporary Allocation</span>
                                    </div>
                                </th>
                                <th>Site Address</th>
                                <th>Customer</th>
                                <th className="table--col-s">Item</th>
                                <th className="table--col-s">Qty</th>
                                <th className="table--col-m">On/Offhire Date</th>
                                <th className="table--col-s">
                                    <div className="tooltipitem tooltipitem__right">Acct
                                        <span className="tooltipitemtext tooltipitemtext__right">Account Type - Prepaid, Account, Account Purchase Order</span>
                                    </div>
                                </th>
                                <th className="table--col-s">Acct. Bal.</th>
                                <th className="table--col-s">Job Amt.</th>
                                <th className="table--col-s">
                                    <div className="tooltipitem tooltipitem__right">Paid
                                        <span className="tooltipitemtext tooltipitemtext__right">Account is ok / Prepaid account paid</span>
                                    </div>
                                </th>
                                <th className="table--col-s">
                                    <div className="tooltipitem tooltipitem__right">Go/Ah
                                        <span className="tooltipitemtext tooltipitemtext__right">Go-ahead sign off recieved and ready for truck allocation</span>
                                    </div>
                                </th>
                                <th className="allocate-notes--width">
                                    <div className="tooltipitem tooltipitem__right">Notes
                                        <span className="tooltipitemtext tooltipitemtext__right">View/Add Notes to the job</span>
                                    </div>
                                </th>
                                <th className="table--col-xs">
                                    <div className="tooltipitem tooltipitem__left">R/O
                                        <span className="tooltipitemtext tooltipitemtext__left">Roll over job to another day</span>
                                    </div>
                                </th>
                                <th className="table--col-xs">Sch</th>
                                <th className="table--col-xs">
                                    <div className="tooltipitem tooltipitem__left">Inv
                                        <span className="tooltipitemtext tooltipitemtext__left">Create a proforma invoice for the job</span>
                                    </div>
                                </th>
                                <th className="table--col-xs"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.scheduleDay.jobs.map((job, index) =>
                                <React.Fragment>
                                    <tr key={index} className={(!job.showItems || job.totalItems === 0) && job.childTypeId === 1 && job.isPlaceholder ? "tableColours--install-ph" : (!job.showItems || job.totalItems === 0) && job.childTypeId === 1 ? "tableColours--install" : (!job.showItems || job.totalItems === 0) && job.childTypeId === 2 && job.isPlaceholder ? "tableColours--pickup-ph" : (!job.showItems || job.totalItems === 0) && job.childTypeId === 2 ? "tableColours--pickup" : (!job.showItems || job.totalItems === 0) && job.childTypeId === 3 ? "tableColours--assist" : (!job.showItems || job.totalItems === 0) && job.childTypeId === 5 ? "tableColours--manual" : ""} onDragStart={() => onDragStart(index)} onDragEnter={() => onDragEnter(index)} onDragEnd={(e) => onDragEnd(e)} draggable>
                                        <td className="hidden">{job.id}</td>
                                        <td className={"table__text--align " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" :  "")}>
                                            <div className={job.totalItems > 0 ? "" : "hidden"}>
                                                <a href="#" onClick={(e) => showItems(e, index, !job.showItems)}>
                                                    <span className={job.showItems ? "fas fa-times copy--icon alignIconCenter" : "fas fa-plus copy--icon alignIconCenter"}></span>
                                                </a>
                                            </div>
                                            <div className={job.totalItems > 0 ? "hidden" : ""}>
                                                {job.jobIndex}
                                            </div>
                                        </td>
                                        <td className={"table__text--align table--col-xs " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" :  "")}>
                                            <div className={job.totalItems > 0 ? "hidden" : ""}>
                                                <a href="#" onClick={(e) => showInfo(e, true, index, job.itemIndex)}>
                                                    <span className="fas fa-info-circle copy--icon alignIconCenter tooltipitem tooltipitem__right"><span className="tooltipitemtext tooltipitemtext__right">Booking Information</span></span>
                                                </a>
                                            </div>
                                        </td>
                                        <td className={"table__text--align table--col-s " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" :  "")}>
                                            <div >
                                                <input name="orderManual" maxLength={50} type={props.scheduleDay.statusId === 1 ? 'text' : "hidden"} className="form-control schedulenew__text-sm" value={job.orderManual} onChange={(e) => onCellChange(e, true, index, job.itemIndex)} />
                                                {props.scheduleDay.statusId === 1 ? "" : job.orderManual}
                                            </div>
                                        </td>
                                        <td className={"table__text--align"}>
                                            <Link className={job.jobId == 0 ? "hidden" : (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" : "")} to={'/job/' + job.jobId + '/details'} target="_blank">
                                                <div className="tooltipitem tooltipitem__right">{job.siteAddress.length > 30 ? job.siteAddress.substring(0, 30) + "... " : job.siteAddress}
                                                    <span className="tooltipitemtext tooltipitemtext__right">{job.siteAddress}</span>
                                                </div>
                                            </Link>
                                            <div className={job.jobId != 0 ? "hidden" : "tooltipitem tooltipitem__right"}>{job.siteAddress ? job.siteAddress.substring(0, 20) + "... " : ""}
                                                <span className="tooltipitemtext tooltipitemtext__right">{job.siteAddress}</span>
                                            </div>
                                        </td>
                                        <td className="table__text--align" >
                                            <Link className={job.customerId === 0 ? "hidden" : "table__text--align " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" : "")} to={'/customer/' + job.customerId} target="_blank">
                                                <div className="tooltipitem tooltipitem__right">{job.customer.length > 15 ? job.customer.substring(0, 15) + "... " : job.customer}
                                                    <span className="tooltipitemtext tooltipitemtext__right">{job.customer}</span>
                                                </div>
                                            </Link>
                                            {job.customerId === 0 ? job.customer : "" }
                                        </td>
                                        <td className={job.totalItems > 0 && !job.itemIsKwikstage && !job.itemIsVoid ? "hidden" : "table__text--align table--col-s " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" : "")}>
                                            <div className={job.totalItems > 0 && !job.itemIsKwikstage && !job.itemIsVoid ? "hidden" : ""}>
                                                <div className="tooltipitem tooltipitem__right">{job.manualItem ? job.description.substring(0, 5) + "... " : job.totalItems > 0 && job.itemIsVoid ? "Void" : job.itemShortcut}
                                                    <span className="tooltipitemtext tooltipitemtext__right">{job.manualItem ? job.description : job.item}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td className={job.totalItems > 0 && !job.itemIsKwikstage && !job.itemIsVoid ? "hidden" : "table__text--align table--cell--nowrap table--col-s " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" : "")}>
                                            <span className="tooltipitemtext tooltipitemtext__right">{job.totalItems > 0 ? job.itemQuantityType : job.quantityType}</span>
                                        </td>
                                        <td className={job.totalItems > 0 && !job.itemIsKwikstage && !job.itemIsVoid ? ("table__text--align " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" : "")) : "hidden"} colSpan={2}>
                                            <span>{job.itemQuantityType}</span>
                                        </td>
                                        <td className={"table__text--align table--col-m "  + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" :  "")}>
                                            <div className={job.totalItems > 0 ? "hidden" : ""}>
                                                <input name="onOffhireDate" type={!job.reckonUpdatesRequired && !job.customerUpdatesRequired && job.allowEdit && !job.manualItem && props.scheduleDay.statusId === 1 ? 'date' : "hidden"} min={minDate} className="form-control schedulenew__date-size" value={job.onOffhireDate} onChange={(e) => onCellChange(e, true, index, job.itemIndex)} />
                                                {!job.reckonUpdatesRequired && !job.customerUpdatesRequired && job.allowEdit && props.scheduleDay.statusId === 1 ? "" : job.onOffhireDateFormatted}
                                            </div>
                                        </td>
                                        <td className={"table__text--align table--col-s "  + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" :  "")}>
                                            <div className="tooltipitem tooltipitem__right">{job.accountTypeId === 1 ? "COD" : job.accountTypeId === 2 ? "Acc" : job.accountTypeId === 3 ? "Acc PO" : ""}
                                                <span className="tooltipitemtext tooltipitemtext__right">{job.accountType}</span>
                                            </div>
                                        </td>
                                        <td className="table__text--align table--col-s">
                                            {job.typeId === 1 ? job.remainingBalanceFormatted : ""}
                                        </td>
                                        <td className="table__text--align table--col-s">
                                            {job.typeId === 1 ? job.jobAmountFormatted : ""}
                                        </td>
                                        <td className={"table__text--align table--col-s "  + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" :  "")}>
                                            <div>
                                                <input name="accountChecked" type='checkbox' className={(job.allowEdit && job.typeId === 1) ? "input" : "hidden"} checked={job.accountChecked} onChange={(e) => onCellJobCheckboxChange(e, index)} disabled={props.scheduleDay.statusId === 2 || !job.allowEdit || (job.accountTypeId === 3 && !job.purchaseOrderNumber)} />
                                                <div className={job.accountTypeId === 3 && job.typeId === 1 && !job.purchaseOrderNumber ? "tooltipitem tooltipitem__right" : "hidden"}>
                                                    <span className="fas fa-circle-exclamation makeitred edit--icon marginLeft10"></span>
                                                    <span className="tooltipitemtext tooltipitemtext__right">Enter Purchase Order Number!</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td className={"table__text--align table--col-s " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" : "")}>
                                            <div>
                                                <input name="goAhead" type='checkbox' className={job.allowEdit ? "input" : "hidden"} checked={job.goAhead} onChange={(e) => onCellJobCheckboxChange(e, index)} disabled={props.scheduleDay.statusId === 2 || !job.allowEdit} />
                                            </div>
                                        </td>
                                        <td className="table__text--align allocate-notes--width">
                                            <div className={job.totalItems > 0 ? "hidden" : "tooltipitem tooltipitem__right"}>
                                                <a className={job.scheduleNotes == "" ? "hidden" : job.showRedNotes ? " makeitred" : ""} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => editNotes(e, true, index, job.itemIndex)}>
                                                    <div className="tooltipitem tooltipitem__left">{job.scheduleNotes ? job.scheduleNotes.length < 60 ? job.scheduleNotes : job.scheduleNotes.substring(0, 60) + "... " : ""}
                                                        <span className="tooltipitemtext tooltipitemtext__large tooltipitemtext__left">{job.scheduleNotes}</span>
                                                    </div>
                                                </a>
                                                <a className={job.scheduleNotes != "" ? "hidden" : job.showRedNotes ? " makeitred" : job.showGreenNotes ? " makeitgreen" : ""} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => editNotes(e, true, index, job.itemIndex)}>
                                                    <span className="fas fa-pencil-alt edit--icon alignIconCenter"></span>
                                                </a>
                                            </div>
                                        </td>
                                        <td className="table__text--align table--col-xs">
                                            <div className={job.totalItems === 0 && (props.allowEdit || props.allowAllocateToPastDate) && job.allowEdit && props.scheduleDay.statusId === 1 && !job.manualItem ? "copy--tablecell" : "hidden"}>
                                                <a href="#" onClick={(e) => copyItemJob(e, true, index, job.itemIndex)}>
                                                    <span className="fas fa-copy copy--icon alignIconCenter tooltipitem tooltipitem__left"><span className="tooltipitemtext tooltipitemtext__left">Roll over job to another day</span></span>
                                                </a>
                                            </div>
                                        </td>
                                        <td className="table__text--align table--col-xs">
                                            <div className={job.totalItems === 0 && (props.allowEdit || props.allowAllocateToPastDate) && job.allowDelete && props.scheduleDay.statusId === 1 ? "" : "hidden"}>
                                                <a href="#" onClick={(e) => rescheduleItem(e, true, index, job.itemIndex)}>
                                                    <span className="fas fa-calendar-alt copy--icon alignIconCenter tooltipitem tooltipitem__left"><span className="tooltipitemtext tooltipitemtext__left">Reschedule job to another day</span></span>
                                                </a>
                                            </div>
                                        </td>
                                        <td className="table__text--align table--col-xs">
                                            <div className={job.childTypeId === 1 && job.allowEdit && job.allowInvoice && props.scheduleDay.statusId === 1 ? "" : "hidden"}>
                                                <a href="#" onClick={(e) => invoiceJob(e, true, index, job.itemIndex)}>
                                                    <span className="fa-solid fa-file-invoice-dollar edit--icon alignIconCenter tooltipitem tooltipitem__left"><span className="tooltipitemtext tooltipitemtext__left">Create a Proforma Invoice for this job</span></span>
                                                </a>
                                            </div>
                                        </td>
                                        <td className="table__text--align table--col-xs">
                                            {job.totalItems === 0 && job.itemStatusId != 8 && props.scheduleDay.statusId === 1 && job.allowDelete ?
                                                <div className="delete--tablecell">
                                                    <a href="#" onClick={(e) => cancelItem(e, true, index, job.itemIndex)}>
                                                        <span className="fas fa-times-circle edit--icon alignIconCenter makeitred tooltipitem tooltipitem__left"><span className="tooltipitemtext tooltipitemtext__left">Cancel Booking</span></span>
                                                    </a>
                                                </div> : ""
                                            }
                                        </td>
                                    </tr>
                                    <tr className={job.showItems ? "" : "hidden"}>
                                        <td className="schedulenew__padding-none" colSpan={18}>
                                            <table className='table subtable--nomargin'>
                                                {job.items.map((item, itemindex) =>
                                                    <tbody key={itemindex}>
                                                        <ItemRow index={itemindex} indexJob={index} item={item} scheduleDayStatusId={props.scheduleDay.statusId} allowEdit={props.allowEdit} allowAllocateToPastDate={props.allowAllocateToPastDate} minDate={minDate} onCellChange={onCellChange} onCellCheckboxChange={onCellCheckboxChange} showInfo={showInfo} rescheduleItem={rescheduleItem} copyItem={copyItemJob} editNotes={editNotes} cancelItem={cancelItem} invoiceItem={invoiceJob} />
                                                    </tbody>
                                                )}
                                            </table>

                                        </td>
                                    </tr>
                                </React.Fragment>
                            )}
                        </tbody>
                    </table>
                    {errors["scheduleItems"] ?
                        (errors["scheduleItems"]).split("\n").map((item: any, key: any) => {
                            return <span className="label errors" key={key}>{item}<br /></span>
                        })
                        : ""}
                    {props.scheduleDay.scheduleErrors.length > 0 ? props.scheduleDay.scheduleErrors.map((item: any, key: any) => {
                            return <span className="label errors" key={key}>{item}<br /></span>
                        })
                        : ""}
                </div>
            </div>
        </div>
    )

    return (
        <div>
            {contents}
        </div>
    );

}

export default ScheduleDayData;
